import { Component, ViewChild } from "@angular/core";
import {IonicPage, NavController, NavParams, ModalController, IonicApp} from 'ionic-angular';
import {BaseConfigProvider} from "../../providers/base-config/base-config";
import {UtilProvider} from "../../providers/util/util";
import {global} from "../../environments/global";
import {MaterialProvider} from "../../providers/material/material";
import {TimeFormatFromNowPipe} from "../../pipes/time-format-from-now/time-format-from-now";
import {MyAlertProvider} from "../../providers/my-alert/my-alert";

/**
 * Generated class for the ChooseMaterialPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-choose-material',
  templateUrl: 'choose-material.html',
})
export class ChooseMaterialPage {

  @ViewChild('mp3') mp3;

  choosed_message_list;

  saveMessage;
  isOnlyLink;
  global = global;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public modalCtrl:ModalController,
              public materialSev:MaterialProvider,
              public util: UtilProvider,
              public myAlert:MyAlertProvider,
              public ionicApp: IonicApp) {

    this.choosed_message_list = this.navParams.data['message_list'] || [];
    this.saveMessage = this.navParams.data['saveMessage'];
    this.isOnlyLink = this.navParams.data['isOnlyLink'] || false;
    this.chooseThisType(this.navParams.data['material_index'] || 0);
  }

  type_list = global.material_type;
  ionViewDidLoad() {
    console.log('ionViewDidLoad ChooseMaterialPage');
  }

  ionViewCanLeave(): boolean{
    return this.util.copeModal(this.ionicApp);
  }

  choosed_index;
  sourceType;
  chooseThisType(i){
    if(i != this.choosed_index){
      this.choosed_index = i;
      this.sourceType = this.type_list[i].real_type;
      this.page = 1;
      this.have_next_data = true;
      if(this.ob_getSourceList){
        this.ob_getSourceList.unsubscribe();
      }
      this.sourceList = [];
      this.getSourceList();
    }
  }



  is_show_loading;
  is_show_nodata;
  page = 1;
  pagesize = 20;
  sourceList = [];
  have_next_data;
  ob_getSourceList;
  getSourceList(){
    // TODO:刷新资源列表
    this.is_show_loading =  true;
    this.is_show_nodata = false;
    this.ob_getSourceList = this.materialSev.getSourceList(this.sourceType,this.page,this.pagesize).subscribe(res =>{
      this.is_show_loading = false;
      if(res['content']['materials'].length < this.pagesize){
        this.have_next_data = false;
      }
      else {
        this.have_next_data = true;
      }
      this.sourceList = this.sourceList.concat(res['content']['materials'].map(material => {
                          // material.duration_str = material.duration? Math.ceil(material.duration/1000):"";
                          material.checked = this.choosed_message_list.some(item => item.msg_id == material.msg_id);
                          return material;
                        }));
    },err =>{
      this.is_show_loading = false;
      this.is_show_nodata = true;
    })
  }

  loadMore(e) {
    var el = e.target;
    if (
      el.scrollTop + el.clientHeight > el.scrollHeight - 1 &&
      !this.is_show_loading &&
      this.have_next_data
    ) {
      this.page ++;
      this.getSourceList();
    }
  }


  onItemClick(type,index){
    switch (type){
      case 3: {
        /*this.util.myNav(this.navCtrl, VideoPlayerPage, {
         src: 'https://vjs.zencdn.net/v/oceans.mp4'
         });*/

        break;
      }
      case 2: {
        // let imgs = this.sourceList.forEach(item =>  {url:item.source_url});

        let imgs = this.sourceList.map(value =>{
          value.url = value.source_url;
          // value.footer_text_left = `${value.client_info.nickname}（来自群：${value.chatroom_info.nickname_real}）`;
          value.footer_text_right = new TimeFormatFromNowPipe().transform(value.create_time);
          return value;
        });


        let modal = this.modalCtrl.create('LargeImgPage',{
          imgs: JSON.stringify(imgs),
          show_index: index,
          disable_point: true
        });
        modal.present();

        break;
      }
      default:{
        this.sourceList[index].checked = !this.sourceList[index].checked;
        this.onCheckedChange(this.sourceList[index].checked,this.sourceList[index]);
      }
    }

  }

  onCheckedChange(is_checked,source){
    if(!this.isOnlyLink){
      if(is_checked){
        if(this.choosed_message_list.length < 5){
          this.choosed_message_list.push(source);
        }
        else {
          source.checked = false;
          let alertObj = {
            type:'warning',
            title:'内容长度超过上限',
            message:'内容上限为5条，请删除后再添加！',
            success: {
              text: '知道了',
            }
          };
          this.myAlert.showAlert(alertObj);
        }
      }
      else {
        let index = -1;
        // for(let i of this.choosed_message_list){
        //   if(this.choosed_message_list[i].msg_id == source.msg_id){
        //     index = i
        //   }
        // }

        this.choosed_message_list.forEach((item,i) =>{
          if(item.msg_id == source.msg_id){
            //noinspection TypeScriptValidateTypes
            index = i;
          }
        });

        this.choosed_message_list.splice(index,1);
      }
    }
    else {
      if(is_checked) {
        this.choosed_message_list = [source];
      }
      else
        this.choosed_message_list = [];
    }
  }

  is_playing_mp3_id = null ;
  is_loading_mp3_id = null ;

  onItemMp3Play(source) {
    let mp3 = this.mp3.nativeElement;
    if (!mp3.paused) {
        // 正在播放、暂停播放
        mp3.pause();
        mp3.currentTime = 0;
        if (this.is_playing_mp3_id === source.msg_id) {
          mp3.currentTime = 0;
          this.is_playing_mp3_id = null;
          return ;
        }
      }
      let src = source.thumb_url;
      if (!src) {
        // 判断mp3链接是否存在
        this.is_loading_mp3_id = source.msg_id;
        this.materialSev.getVoice(source.msg_id).subscribe(res =>{
          this.is_loading_mp3_id = null;
          if(res['err_code'] == 0 && res['content']['resource']){
            src =  res['content']['resource'];
            source.thumb_url = src;
            this.playMp3(mp3, source, src);
          }
        }, err =>{
          this.is_loading_mp3_id = null;
          return;
        });
      } else {
        this.playMp3(mp3, source, src);
      }
  }

  saveChoose(){
    this.saveMessage(this.choosed_message_list);
    this.navCtrl.pop();
  }

  playMp3(mp3, source, src) {
    mp3.pause();
    mp3.src = src;
    this.is_playing_mp3_id = source.msg_id;
    mp3.currentTime = 0;
    mp3.play();
  }
}



// WEBPACK FOOTER //
// ./src/pages/choose-material/choose-material.ts